import { usePublishedData } from "../lib/published-data";
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import servicesStyles from "../styles/services.css?url";
import { DocumentContent } from "../components/document-content";
import { TournamentsContent } from "../components/services/tournaments";
import { useShell } from "../lib/document-route";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadTournaments } from "../server/services";

/** Tournaments (/tournaments): the page the creator composed, with the list at its built-in block, or the native page. */
export const Route = createFileRoute("/tournaments/")({
  loader: async () => {
    const data = await loadTournaments();
    if (data.kind === "missing") throw notFound();
    if (data.kind === "redirect") throw redirect({ href: data.to, statusCode: 302 });
    return data;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    const head =
      loaderData.kind === "page"
        ? creatorPageHead(shell, {
            pathname: "/tournaments",
            title: loaderData.page.seoTitle || loaderData.page.title,
            description: loaderData.page.description,
            noindex: loaderData.private || loaderData.locked || loaderData.page.hideFromSearch,
            preloadImage: loaderData.lead,
          })
        : creatorPageHead(shell, {
            pathname: "/tournaments",
            title: `Tournaments | ${shell.creator.name}`,
            description:
              loaderData.tournaments.intro || "Upcoming tournaments and registration links.",
            noindex: loaderData.tournaments.preview,
          });
    return withStylesheet(head, servicesStyles);
  },
  component: Tournaments,
});

function Tournaments() {
  const initial = Route.useLoaderData();
  const shell = useShell();
  const { data } = usePublishedData(initial, shell, "/tournaments", "page");
  const content = <TournamentsContent tournaments={data.tournaments} />;
  return data.kind === "page" ? (
    <DocumentContent data={data} shell={shell} builtIn={content} />
  ) : (
    content
  );
}
